module.exports = __webpack_public_path__ + "img/2.e774b28e.png";